"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OA_LOGIN = void 0;
// import { createApp } from '@bone/console';
var login_1 = __importDefault(require("./pages/oa/login"));
exports.OA_LOGIN = login_1.default;
// export default createApp({
//   routes: [
//     {
//       path: '/login',
//       component: OA_LOGIN,
//     },
//   ],
// });
